import { CIMSColumnsOptions } from 'components/CIMSTable/CIMSColumn/types'
import { HelpMessage } from 'utils/constants'
import { ConcreteMixDesign } from '../MixDesignsContext/types'
import { useStatusColumn } from '../../../hooks/useStatusColumn'
import { useConcreteMixDesignsContext } from '../MixDesignsContext'
import { useMixDesignNumberColumn } from '../../../hooks/useMixDesignNumberColumn'
import { useExpirationDateColumn } from '../../../hooks/useExpirationDateColumn'

const Help = HelpMessage.Materials.Concrete

export function useColumns(): CIMSColumnsOptions<ConcreteMixDesign> {
  const { edit, refetch } = useConcreteMixDesignsContext()
  return {
    columns: [
      useStatusColumn(),
      useMixDesignNumberColumn(Help.Number),
      {
        title: 'Supplier',
        help: Help.Source,
        width: 150,
        render: 'materialSource',
        filter: { type: 'search', with: 'key', key: 'materialSource' },
      },
      {
        title: 'Class',
        help: Help.Class,
        width: 150,
        render: 'class',
        sort: {
          with: 'key',
          key: 'class',
          default: 'ascend',
          priority: 3,
        },
        filter: { type: 'search', with: 'key', key: 'class' },
      },
      {
        title: 'Use',
        help: Help.Use,
        width: 150,
        render: 'concreteUse',
        filter: { type: 'search', with: 'key', key: 'concreteUse' },
      },
      {
        title: 'Submittal ID',
        help: Help.SubmittalID,
        width: 175,
        sort: { with: 'key', key: 'submittalId' },
        filter: { type: 'search', with: 'key', key: 'submittalId' },
        render: 'submittalId',
      },
      useExpirationDateColumn(Help.ExpirationDate),
    ],
    prominentCustomFields: {
      disableEditWhen: ({ active }) => ({
        alreadyDisabled: false,
        recordInactive: !active,
      }),
      onCheckBoolean: async ({ globalId }, input) => {
        await edit({
          variables: {
            input: {
              globalId,
              customFields: { booleanInputs: [input] },
            },
          },
        })
        refetch()
      },
      onCheckBooleans: async ({ globalId }, input) => {
        await edit({
          variables: {
            input: {
              globalId,
              customFields: { listInputs: { checkboxes: [input] } },
            },
          },
        })
        refetch()
      },
    },
  }
}
